import type { ReactElement } from "react";
import { CmtsReportExportsContainer } from "../../core/containers/domain/reportsRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsReportExportsContainer runtime={props.runtime} />;
}

export default Component;
